
export const detect_result_columns = [
  {
    title: '检测项',
    dataIndex: 'detect_item',
    width: '25%',
    align: 'center',
    scopedSlots: { customRender: 'detect_item' },
  },
  {
    title: '结果',
    dataIndex: 'result',
    width: '25%',
    align: 'center',
    scopedSlots: { customRender: 'result' },
  },
  {
    title: '检测项',
    dataIndex: 'detect_item_1',
    width: '25%',
    align: 'center',
    scopedSlots: { customRender: 'detect_item_1' },
  },
  {
    title: '结果',
    dataIndex: 'result_1',
    align: 'center',
    scopedSlots: { customRender: 'result_1' },
  },
];


export const customer_columns = [
  {
    title: '姓名项',
    dataIndex: 'name_item',
    width: '12%',
    scopedSlots: { customRender: 'name_item' },
  },
  {
    title: '姓名',
    dataIndex: 'name',
    width: '20%',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '电话项',
    dataIndex: 'mobile_item',
    width: '12%',
    scopedSlots: { customRender: 'mobile_item' },
  },
  {
    title: '电话',
    dataIndex: 'mobile',
    width: '20%',
    scopedSlots: { customRender: 'mobile' },
  },
  {
    title: '身份证项',
    dataIndex: 'id_item',
    width: '12%',
    scopedSlots: { customRender: 'id_item' },
  },
  {
    title: '身份证号',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
  },
];

export const base_info_columns = [
  {
    title: '项目名称',
    dataIndex: 'info_item',
    width: '12%',
    scopedSlots: { customRender: 'info' },
  },
  {
    title: '项目',
    dataIndex: 'info',
    width: '20%',
    scopedSlots: { customRender: 'info' },
  },
  {
    title: '项目名称1',
    dataIndex: 'info_item_1',
    width: '12%',
    scopedSlots: { customRender: 'info_item_1' },
  },
  {
    title: '项目1',
    dataIndex: 'info_1',
    width: '20%',
    scopedSlots: { customRender: 'info_1' },
  },
  {
    title: '项目名称2',
    dataIndex: 'info_item_2',
    width: '12%',
    scopedSlots: { customRender: 'info_item_2' },
  },
  {
    title: '项目2',
    dataIndex: 'info_2',
    scopedSlots: { customRender: 'info_2' },
  },
];